/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundDto } from '../../models/backend-venture-fund-dto';
import { BackendVentureFundRequestDto } from '../../models/backend-venture-fund-request-dto';

export interface VentureFundsVentureFundsUpdate$Params {
  id: number;
  body: BackendVentureFundRequestDto;
}

export function ventureFundsVentureFundsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundDto>;
    }),
  );
}

ventureFundsVentureFundsUpdate.PATH = '/api/venture_funds/venture-funds/{id}/';
